"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/material/styles");

var _Step = _interopRequireDefault(require("./Step"));

var _colors = require("../../colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Line = (0, _styles.styled)('div')(function () {
  return {
    background: _colors.GREY7,
    width: '42px',
    height: '1px'
  };
});

var CircleSteps = function CircleSteps(_ref) {
  var steps = _ref.steps;
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    alignItems: "center",
    sx: {
      width: 'auto'
    }
  }, steps.map(function (step, idx) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: step.value
    }, /*#__PURE__*/_react.default.createElement(_Step.default, {
      value: step.value,
      selected: step.selected
    }), idx !== steps.length - 1 && /*#__PURE__*/_react.default.createElement(Line, null));
  }));
};

var _default = CircleSteps;
exports.default = _default;